import { drawerClasses, SxProps } from '@mui/material'

export interface BottomDrawerStyles {
  wrapper: SxProps
  contentWrapper: SxProps
  contentWrapperNoBottomSpacing: SxProps
  heading: SxProps
  headingText: SxProps
  closeIcon: SxProps
  mainContent: SxProps
}

export const bottomDrawerStyles: BottomDrawerStyles = {
  wrapper: {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    [`.${drawerClasses.anchorRight} &.${drawerClasses.paper}`]: {
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 12,
    },
  },
  contentWrapper: { p: 3, display: 'flex', flexDirection: 'column', gap: 2 },
  contentWrapperNoBottomSpacing: {
    pb: 0,
  },
  heading: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  headingText: { typography: 'textLgSemibold', color: 'text.primaryLight' },
  closeIcon: {
    color: 'button.textDisabledSecondary',
    height: 24,
    width: 24,
    cursor: 'pointer',
    p: 0,

    '.icon': {
      width: 24,
    },
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxHeight: '75svh',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
}
